import { FeatureFlag, useIsFlagEnabled } from '@/hooks/useIsFlagEnabled'
import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { isStaff } from '@/utils/type-guards'

/**
 * True when the logged-in staff member must only see the simplified reception interface:
 * the `simplified-reception-mode` flag is on, they are reception staff (PDS) and an admin turned the mode on for them.
 */
export function useIsSimplifiedReceptionLocked(): boolean {
  const isFlagOn = useIsFlagEnabled(FeatureFlag.SimplifiedReceptionMode)
  const authUser = useAppSelector(selectAuthUser)
  // Reception staff (PDS) only: a doctor always keeps the usual application, even with a stale value.
  return isFlagOn && isStaff(authUser) && authUser.status === 'PDS' && !!authUser.simplifiedReceptionMode
}
